import React from 'react';
import PropTypes from 'prop-types';
import Icon from '~/components/Icon/Icon';
import Tooltip from '@sumologic/yama-ds-components/components/Tooltip';

function ButtonBoxed({ icon, active, disabled, label, tooltip, onClick }) {
    let classes = ['icon-box'];

    if (active) classes.push('active');
    if (disabled) classes.push('disabled');

    const handleTooltip = children => {
        if (tooltip)
            return (
                <Tooltip
                    title={tooltip}
                    placement="bottom"
                    arrow
                >
                    {children}
                </Tooltip>
            );
        return children;
    };

    return (
        <span
            className="button-boxed"
            onClick={() => {
                if (!disabled) onClick();
            }}
        >
            {handleTooltip(
                <span
                    className={classes.join(' ')}
                    data-testid={'icon-container'}
                >
                    <Icon type={icon} />
                </span>
            )}
            {label && <span className="label-box">{label}</span>}
        </span>
    );
}

export default ButtonBoxed;

ButtonBoxed.propTypes = {
    icon: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    disabled: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    tooltip: PropTypes.any,
    onClick: PropTypes.func
};
